import React, { useCallback } from 'react'
import intl from 'react-intl-universal'
import { Form, Input, TextArea, Picker, Checkbox, Space, Radio } from 'antd-mobile'
import { RightOutline } from 'antd-mobile-icons'
import dayjs from 'dayjs'
import { formatJSON } from '../../utils'
import { getScopeParam, getCodeExtendColumn } from '../../utils/session/store'
import PaymentMethodItem from './PaymentMethodItem'
import RemarkIcon from '../Icon/RemarkIcon'
import './index.less'

export default function ExtendFormItem({ storeInfo = {}, productExtendData, from = '' }) {
    const { extendColumn1 = '' } = storeInfo || {}
    const extendObj = formatJSON(extendColumn1)
    const codeExtData = getCodeExtendColumn()
    const { areaType } = getScopeParam() || {}
    if (productExtendData && typeof productExtendData === 'string') {
        productExtendData = formatJSON(productExtendData)
    }


    const placeText = intl.get('pls_input_x', { word: '...' }).d('Please input...')

    //merchant setting first
    let {
        firstName = 3,
        lastName = 3,
        roomNo = 3,
        phone = 3,
        email = 3,
        payMethods = {},
        hotelFlag = 3,
        hotelNames,
        otherItems,
        enableDiners = false,
        onlinePay = {},
        whatsAppId = 3,
        roomDayPassUnitNo = 3,
        address = 3
    } = extendObj || {}

    let remarkFlag = storeInfo.isOpenOrderRemark || false
    let startTimeDate = 3

    // qr code setting secondary
    if (codeExtData && Object.keys(codeExtData).length > 0) {
        if (codeExtData.firstName && codeExtData.firstName !== 4) {
            firstName = codeExtData.firstName
        }
        if (codeExtData.lastName && codeExtData.lastName !== 4) {
            lastName = codeExtData.lastName
        }
        if (codeExtData.roomNo && codeExtData.roomNo !== 4) {
            roomNo = codeExtData.roomNo
        }
        if (codeExtData.phone && codeExtData.phone !== 4) {
            phone = codeExtData.phone
        }
        if (codeExtData.email && codeExtData.email !== 4) {
            email = codeExtData.email
        }
        if (codeExtData.hotelFlag && codeExtData.hotelFlag !== 4) {
            hotelFlag = codeExtData.hotelFlag
            hotelNames = codeExtData.hotelNames
        }
        if (codeExtData.estimatedDelivery && codeExtData.estimatedDelivery !== 4) {
            startTimeDate = codeExtData.estimatedDelivery
        }

        if (codeExtData.whatsAppId && codeExtData.whatsAppId !== 4) {
            whatsAppId = codeExtData.whatsAppId
        }

        if (codeExtData.roomDayPassUnitNo && codeExtData.roomDayPassUnitNo !== 4) {
            roomDayPassUnitNo = codeExtData.roomDayPassUnitNo
        }

        if (codeExtData.otherItems) {
            otherItems = codeExtData.otherItems
        }
        if (codeExtData.address && codeExtData.address !== 4) {
            address = codeExtData.address
        }
    }

    //product setting last
    if (productExtendData && Object.keys(productExtendData).length > 0) {
        if (!remarkFlag) {
            remarkFlag = productExtendData.isOpenOrderRemark
        }

        if (productExtendData.firstName) {
            firstName = productExtendData.firstName
        }
        if (productExtendData.lastName) {
            lastName = productExtendData.lastName
        }
        if (productExtendData.roomNo) {
            roomNo = productExtendData.roomNo
        }
        if (productExtendData.phone) {
            phone = productExtendData.phone
        }
        if (productExtendData.email) {
            email = productExtendData.email
        }
        if (productExtendData.hotelFlag) {
            hotelFlag = productExtendData.hotelFlag
            hotelNames = productExtendData.hotelNames
        }
        if (productExtendData.remark) {
            remarkFlag = productExtendData.remark
        }
        if (productExtendData.dinersNum) {
            enableDiners = productExtendData.dinersNum
        }

        if (productExtendData.otherItems) {
            otherItems = productExtendData.otherItems
        }

        if (productExtendData.whatsAppId) {
            whatsAppId = productExtendData.whatsAppId
        }
        if (productExtendData.roomDayPassUnitNo) {
            roomDayPassUnitNo = productExtendData.roomDayPassUnitNo
        }
        if (productExtendData.address) {
            address = productExtendData.address
        }
    }

    const hotelColumns = hotelNames && hotelNames.length > 0 ? hotelNames.split(',').map(item => {
        return {
            label: item,
            value: item
        }
    }) : []

    const culExpectedTime = () => {
        const date = new Date()
        const currentTime = date.getTime()
        const dateStr = dayjs(date).format('YYYY/MM/DD')
        const minuteIntervals = ['00', '15', '30', '45']
        const expectedTimes = []

        // 获取当前小时和分钟
        let currentHour = date.getHours()
        const currentMinute = date.getMinutes()

        // 如果当前分钟超过45分钟，从下一个小时开始
        if (currentMinute > 45) {
            currentHour += 1
        }

        // 生成未来15分钟后的时间选项
        const minTimeDifference = 15 * 60 * 1000 // 15分钟的毫秒数

        for (let hour = currentHour; hour < 24; hour++) {
            minuteIntervals.forEach(minute => {
                const timeString = `${dateStr} ${hour.toString().padStart(2, '0')}:${minute}`
                const timeInMs = new Date(timeString).getTime()

                // 只添加15分钟后的时间选项
                if (timeInMs - currentTime > minTimeDifference) {
                    expectedTimes.push(`${hour.toString().padStart(2, '0')}:${minute}`)
                }
            })
        }

        return expectedTimes
    }

    const otherItemLens = (obj) => {
        const arr = []
        for (let o in obj) {
            if (obj[o].checkFlag !== '3') {
                arr.push(o)
            }
        }
        return arr.length > 0
    }

    const renderOtherItems = useCallback((objItems) => {
        const items = []
        for (let key in objItems) {
            var { checkFlag, title, inputType, values } = objItems[key]
            const label = intl.get(key).d(title)
            if (checkFlag !== '3') {
                const isRequired = checkFlag === '1'
                let columns = []
                if (values && values.length > 0) {
                    columns = values.split(',').map(item => {
                        return {
                            label: item,
                            value: item
                        }
                    })
                }

                let formItem = null
                switch (inputType) {
                    case 'text':
                        formItem = <Form.Item key={key} name={key} label={label} rules={[{ required: isRequired }]}>
                            <Input placeholder={placeText} />
                        </Form.Item>
                        break
                    case 'checkbox':
                        formItem = <Form.Item key={key} name={key} label={label} rules={[{ required: isRequired }]}>
                            <Checkbox.Group>
                                <Space>
                                    {columns.map(option => (
                                        <div key={option.value}>
                                            <Checkbox value={option.value}>{option.label}</Checkbox>
                                        </div>
                                    ))}
                                </Space>
                            </Checkbox.Group>
                        </Form.Item>

                        break
                    case 'radio':
                        formItem = <Form.Item key={key} name={key} label={label} rules={[{ required: isRequired }]}>
                            <Radio.Group>
                                {columns.map(option => (
                                    <div key={option.value}>
                                        <Radio value={option.value}>{option.label}</Radio>
                                    </div>
                                ))}
                            </Radio.Group>
                        </Form.Item>
                        break
                    case 'select':
                        formItem = <Form.Item
                            key={key}
                            name={key}
                            label={label}
                            trigger='onConfirm'
                            onClick={(e, pickerRef) => {
                                pickerRef.current.open()
                            }}
                            arrowIcon={<RightOutline />}
                            rules={[{ required: isRequired }]}
                            className='custom-picker-style'
                        >
                            <Picker
                                confirmText={intl.get('ok').d('确定')}
                                cancelText={intl.get('cancel').d('取消')}
                                columns={[columns]}  >
                                {
                                    value => {
                                        let label = intl.get('pls_select').d('请选择')
                                        if (value && value.length > 0) {
                                            label = value[0]?.label || intl.get('pls_select').d('请选择')
                                        }
                                        return label
                                    }
                                }
                            </Picker>
                        </Form.Item>
                        break
                    default:
                        break
                }
                if (formItem) {
                    items.push(formItem)
                }
            }
        }
        return items
    }, [placeText])

    const notFromModal = from !== 'modal'
    const hasOtherFields = () => {
        const hasFirstName = firstName !== 3
        const hasLastName = lastName !== 3
        const hasRoomNo = roomNo !== 3
        const hasPhone = phone !== 3
        const hasEmail = email !== 3
        const hasHotelFlag = hotelFlag !== 3
        const hasOtherItems = otherItems && Object.keys(otherItems).length > 0 && otherItemLens(otherItems) ? true : false
        const hasEnableDiners = enableDiners
        const hasOfflinePay = payMethods && Object.keys(payMethods).length > 0
        const hasOnlinePay = onlinePay && onlinePay.isEnabled

        return hasFirstName || hasLastName || hasRoomNo || hasPhone || hasEmail || hasHotelFlag || hasOtherItems || hasEnableDiners || hasOfflinePay || hasOnlinePay
    }

    const hasRemark = remarkFlag || (extendObj && extendObj.isOpenOrderRemark)
    const otherFields = hasOtherFields()

    //如果是外部码,而且没有设置过其他字段，roomNo,firstName,phone,deliveryTime必填
    let expectedTimes = culExpectedTime()

    return (
        <div className='extend-form-item'>
            {
                hasRemark && (
                    <div className='bk-list-wrapper extend-remark-wrapper'>
                        <div className='jm-flex' style={{ alignItems: 'flex-start' }}>
                            <div className={notFromModal ? 'bk-left' : 'hide'}>
                                <RemarkIcon width={24} height={24} color='var(--adm-color-primary)' />
                            </div>
                            <div className='bk-right jm-flex-item'>
                                <Form.Item
                                    name='remark'
                                    label={intl.get('order_remark').d('Remark')}
                                    style={!notFromModal ? { backgroundColor: '#fff' } : null}
                                >
                                    <TextArea rows={2} maxLength={100} showCount placeholder={placeText} />
                                </Form.Item>
                            </div>
                        </div>

                    </div>
                )
            }
            {
                otherFields && (
                    <div className={`bk-list-wrapper m-t-sm ${notFromModal ? 'custom-form-wrapper' : ''}`}>
                        <div className='jm-flex'>
                            <div className={notFromModal ? 'bk-left' : 'hide'}>
                                <div style={{ width: 18 }}>&nbsp;</div>
                            </div>
                            <div className='bk-right jm-flex-item'>
                                {
                                    notFromModal && (
                                        <PaymentMethodItem payMethods={payMethods} onlinePay={onlinePay} />
                                    )
                                }

                                {
                                    firstName !== 3 && (
                                        <Form.Item
                                            name='firstName'
                                            label={intl.get('first_name').d('First Name')}
                                            rules={[{ required: firstName === 1, message: 'Please input your first name!' }]}>
                                            <Input placeholder={placeText} />
                                        </Form.Item>
                                    )
                                }
                                {
                                    lastName !== 3 && (
                                        <Form.Item name='lastName' label={intl.get('last_name').d('Last Name')} rules={[{ required: lastName === 1, message: 'Please input your last name!' }]}>
                                            <Input placeholder={placeText} />
                                        </Form.Item>
                                    )
                                }
                                {
                                    roomNo !== 3 && (
                                        <Form.Item
                                            name='roomNo'
                                            label={intl.get('room_no').d('Room No.')}
                                            rules={[{ required: roomNo === 1, message: 'Please input your room no!' }]}>
                                            <Input placeholder={placeText} />
                                        </Form.Item>
                                    )
                                }
                                {
                                    phone !== 3 && (
                                        <Form.Item
                                            name='phone'
                                            label={intl.get('phone').d('Phone Number')}
                                            rules={[{ required: phone === 1, message: 'Please input your phone!' }]}>
                                            <Input placeholder={placeText} />
                                        </Form.Item>
                                    )
                                }
                                {
                                    email !== 3 && (
                                        <Form.Item
                                            name='email'
                                            label={intl.get('email').d('Email')}
                                            rules={[{ required: email === 1, message: 'Please input your email!' }]}>
                                            <Input placeholder={placeText} />
                                        </Form.Item>
                                    )
                                }

                                {
                                    hotelFlag !== 3 && (
                                        hotelNames && hotelNames.length > 0
                                            ?
                                            <Form.Item
                                                name='hotelName'
                                                label={intl.get('hotel').d('酒店')}
                                                trigger='onConfirm'
                                                rules={[{ required: hotelFlag === 1, message: intl.get('pls_sel_hotel').d('请选择酒店') }]}
                                                onClick={(e, pickerRef) => {
                                                    pickerRef.current.open()
                                                }}
                                                arrowIcon={<RightOutline color='var(--adm-color-primary)' />}
                                                className='custom-picker-style'
                                            >
                                                <Picker columns={[hotelColumns]} >
                                                    {
                                                        value => {
                                                            let label = intl.get('pls_sel_hotel').d('请选择酒店')
                                                            if (value && value.length > 0) {
                                                                label = value[0]?.label || intl.get('pls_sel_hotel').d('请选择酒店')
                                                            }
                                                            return label
                                                        }
                                                    }
                                                </Picker>
                                            </Form.Item>
                                            :
                                            <Form.Item name='hotelName'
                                                label={intl.get('hotel').d('酒店')}
                                                rules={[{ required: hotelFlag === 1 }]}>
                                                <Input placeholder={placeText} maxLength={50} />
                                            </Form.Item>
                                    )
                                }
                                {
                                    otherItems && Object.keys(otherItems).length > 0 && renderOtherItems(otherItems)
                                }

                                {
                                    enableDiners && (
                                        <Form.Item
                                            label={intl.get('diners_num').d('宾客人数')}
                                            required
                                            className='diners-group-item'
                                        >
                                            <div className='diners-group-fields'>
                                                <div className='diners-field-row'>
                                                    <span className='diners-field-label'>
                                                        {intl.get('adult').d('成人')}
                                                        <span className='diners-field-required'>*</span>
                                                    </span>
                                                    <Form.Item name='adultNum' noStyle rules={[{ required: true }]}>
                                                        <Input type='number' placeholder={placeText} maxLength={10} />
                                                    </Form.Item>
                                                </div>
                                                <div className='diners-field-row'>
                                                    <span className='diners-field-label'>{intl.get('children').d('儿童')}</span>
                                                    <Form.Item name='childrenNum' noStyle>
                                                        <Input type='number' placeholder={placeText} maxLength={10} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Form.Item>
                                    )
                                }
                                {
                                    whatsAppId !== 3 && (
                                        <Form.Item name='whatsAppId' label={intl.get('whatsAppId').d('WhatsApp ID')} rules={[{ required: whatsAppId === 1 }]}>
                                            <Input placeholder={placeText} />
                                        </Form.Item>
                                    )
                                }
                                {
                                    roomDayPassUnitNo !== 3 && (
                                        <Form.Item name='roomDayPassUnitNo' label='Room/Daypass/Unit No.' rules={[{ required: roomDayPassUnitNo === 1 }]}>
                                            <Input placeholder={placeText} />
                                        </Form.Item>
                                    )
                                }
                                {
                                    address !== 3 && (
                                        <Form.Item name='address' label={intl.get('address').d('Address')} rules={[{ required: address === 1 }]}>
                                            <Input placeholder={placeText} />
                                        </Form.Item>
                                    )
                                }
                            </div>
                        </div>

                    </div>
                )
            }

            {
                startTimeDate !== 3 && (
                    <div className={`bk-list-wrapper m-t-sm ${notFromModal ? 'custom-form-wrapper' : ''}`}>
                        <div className='jm-flex'>
                            <div className={notFromModal ? 'bk-left' : 'hide'}>
                                <div style={{ width: 18 }}>&nbsp;</div>
                            </div>
                            <div className='bk-right jm-flex-item'>
                                <Form.Item name='startTimeDate'
                                    label={intl.get('expected_time_of_delivery').d('Expected time of delivery')}
                                    rules={[{ required: startTimeDate === 1 }]}

                                    trigger='onConfirm'
                                    onClick={(e, pickerRef) => {
                                        pickerRef.current.open()
                                    }}
                                    arrowIcon={<RightOutline />}
                                    className='custom-picker-style'
                                >
                                    <Picker
                                        confirmText={intl.get('ok').d('确定')}
                                        cancelText={intl.get('cancel').d('取消')}
                                        columns={[
                                            expectedTimes.map(item => ({ label: item, value: item }))
                                        ]}  >
                                        {
                                            value => {
                                                let label = intl.get('pls_select').d('请选择')
                                                if (value && value.length > 0) {
                                                    label = value[0]?.label || intl.get('pls_select').d('请选择')
                                                }
                                                return label
                                            }
                                        }
                                    </Picker>
                                </Form.Item>
                            </div>
                        </div>
                    </div>


                )
            }

        </div>
    )
}
